 const color = {
    primary: "#f58b1e",
    secondary: "#eea849",
    tertiary: "#454546",
    quaternary: "#ffa952",
  
    gray: "#707070",
    white: "#fff",
    red: "#f51e25",
    green: "#3CF580",
    yellow: "#FFD632",

    greenDarker: "#45F47F",

    secondaryDark: "#eea94993",
    grayDark: "#b8b4cc",
    redDark: "#F46B45",
    greenDark: "#1EF591",
    

    primaryLight: "#ffcd8b",
    grayLight: "#f2f1fa",
    blackLight: "#172b4d",
    brownLight: "#ebd3c9",
    yellowLight: "#fef9f2",
    redLight: "#ffdcd3",
    
    primaryLighter: "#ffcaae82",
    grayLighter: "#f2f2f2",
    greenLighter: "#f0fef5",

    grayLightest: "#f6f5fa",

    scrollBarBackground: "#f4f4f4",
    scrollBarThumb: "#dad7d7",

    ballonBackground: "#faf3f1",

    ballonShadow: "#fbd4cca3",

    textRed: "#f46b45",

    planName: "#d1d1d1",

    lastTransferBackground: "#f46b45",

    sideBarBorder: "#e6e9f2",

    tableShadow: "#2c28281c",

    circleOptionBorder: "#f7fafc",

    filterShadow: "#b4b4b46e",

    checkboxShadow: "#DCDCDC30",

    ricepaper: "#FAF8F5",

    anpacsBlood: "#F6F5FA"
} 

export default color;